module.exports = __webpack_public_path__ + "static/media/icon-okta.dd02f732.svg";